import axios from "axios";
import Env from "/env";
import Vue from "vue";

const adminHttp = axios.create({
    baseURL: `${Env.API_URL}`,
    headers: {
        "Content-Type": "application/json",
    }
})

// const adminHttpAdmin = axios.create({
//     baseURL: `${Env.API_URL_ADMIN || 'https://backendtest.bigplay.gg/api/admin'}`,
//     headers: {
//         "Content-Type": "application/json",
//     }
// });

/**
 * Request Interceptors
 */
const getAuthToken = () => localStorage.getItem('token')
const getAuthUserId = () => localStorage.getItem('user_id')
const authInterceptor = (config) => {
    const token = getAuthToken()
    const userId = getAuthUserId()
    if (token && userId) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    config.headers['Accept-Language'] = 'ru'
    return config
}
adminHttp.interceptors.request.use(authInterceptor)
// adminHttpAdmin.interceptors.request.use(authInterceptor);

const AUTH_PATH = '/auth'
const LOGIN_ENDPOINT = '/api/v1/client/auth/login/via-email'

const isLoginRequest = (e) => {
    const url = e?.response?.config?.url || e?.config?.url || ''
    return url.includes(LOGIN_ENDPOINT)
}

const handleUnauthorized = () => {
    if (window.location.pathname === AUTH_PATH) return
    localStorage.clear()
    window.location.href = AUTH_PATH
}

const WRITE_METHODS = ['post', 'put', 'patch', 'delete']

const extractErrorMessage = (e) => {
    const data = e?.response?.data
    if (data?.errors && typeof data.errors === 'object') {
        const messages = Object.values(data.errors).flat().filter(Boolean)
        if (messages.length) return messages.join('\n')
    }
    if (typeof data?.message === 'string' && data.message) return data.message
    if (typeof data === 'string' && data) return data
    if (e?.message) return e.message
    return 'Произошла ошибка при выполнении запроса'
}

const errorInterceptor = e => {
    const status = e?.response?.status
    const config = e?.config || e?.response?.config || {}
    switch (status) {
        case 401:
            console.log('###', status, e.message)
            if (!isLoginRequest(e)) handleUnauthorized()
            break
        case 403:
            console.log('###', status, e.message)
            Vue.toasted.error('У вашей роли нет доступа', {
                duration: 5000
            });
            break
        default:
            if(process.env.NODE_ENV === 'development')
                console.log('### ', status, e.message, e?.response)
            if (!config.skipErrorToast) {
                Vue.toasted.error(extractErrorMessage(e), {
                    duration: 5000
                });
            }
    }
    return Promise.reject(e)
}

const responseInterceptor = r => {
    const method = (r?.config?.method || '').toLowerCase()
    if (!r?.config?.skipSuccessToast && WRITE_METHODS.includes(method)) {
        const message = (typeof r?.data?.message === 'string' && r.data.message)
            ? r.data.message
            : 'Успешно'
        Vue.toasted.success(message, {
            duration: 3000
        })
    }
    return r
}

adminHttp.interceptors.response.use(responseInterceptor, errorInterceptor)
// adminHttpAdmin.interceptors.response.use(responseInterceptor, errorInterceptor);


export default adminHttp;